/* eslint-disable camelcase */
import { AUTH_ORIGIN, GET_ORIGIN, WWW_ORIGIN } from '../../config';

export default {
  getMe() {
    return fetch(`${AUTH_ORIGIN}/v1/user/me`, {
      credentials: 'include',
      headers: {
        Cookie: document.cookie,
        'Content-Type': 'application/json',
      },
    })
      .then(async (res) => {
        let response;
        try {
          response = await res.json();
        } catch (error) {
          throw new Error(
            'Failed to parse JSON response: ' + JSON.stringify(error)
          );
        }

        const pathname = window.location.pathname;
        switch (res.status) {
          case 422:
            // no redirect - partial user needs to access URP at account/register
            if (
              pathname.startsWith('/account/register') ||
              pathname.startsWith('/account/buyer/')
            ) {
              return false;
            } else {
              return window.location.assign(
                `${WWW_ORIGIN}/quoting/complete-registration?redirect=${encodeURIComponent(
                  window.location.href
                )}`
              );
            }
          case 401:
            if (
              pathname.startsWith('/account/buyer/') ||
              pathname === '/account/ulp-forgot-password' ||
              pathname === '/account/ulp-reset-password' ||
              pathname === '/account/forgot-password' ||
              pathname.startsWith('/account/reset-password')
            ) {
              return;
            }
            return window.location.assign(
              `${WWW_ORIGIN}/login?domain=www&destination=${
                window.location.pathname
              }${encodeURIComponent(window.location.search)}`
            );
          case 200:
            if (!response) {
              return window.location.assign(`${GET_ORIGIN}/login`);
            }
            return response;
          default:
            throw Error(`${res.status} ${res.statusText}`);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },

  redirectToRefreshToken(domain: string, destination: string) {
    window.location.assign(`
      ${WWW_ORIGIN}/refresh-tokens?domain=${domain}&destination=${destination}
    `);
  },
};
